import { render } from "./tw-confirm.vue?vue&type=template&id=7b7ea107"
import script from "./tw-confirm.vue?vue&type=script&lang=js"
export * from "./tw-confirm.vue?vue&type=script&lang=js"
script.render = render

export default script